<template>
  <div>Downloading Pattern...</div>
</template>
<script>
import Db from '@/helpers/Db';
export default {
  name: 'PatternView',
  async mounted() {
    const tutorial = await Db.getTutorialBySlug(this.$route.params.id);

    const fullTutorial =  await Db.fetchTutorial(tutorial.id)
    
    if (!fullTutorial) return;
    
    const download = (url) => {
      fetch(url)
        .then( res => res.blob() )
        .then( blob => {
          var file = window.URL.createObjectURL(blob);
          window.location.assign(file);
        });
    }; 

    download(fullTutorial.pattern_download_url);
  },
}
</script>